import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { FinancialEntityNameFailure, FinancialEntityNameRequest, FinancialEntityNameSuccess } from './actions';
import { ParameterResult } from '@models/swagger';

export const featureKey = 'financialEntityName';

export interface State {
  data: ParameterResult | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: null,
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(FinancialEntityNameFailure, (state, { error }) => ({ ...state, data: null, error, loading: false })),
    on(FinancialEntityNameRequest, state => ({ ...state, error: null, loading: true })),
    on(FinancialEntityNameSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false }))
  )(state, action);
}
